import { useEffect, useState } from "react";
import HomePage from "../HomePage/HomePage";
import { BESTTALENTS, REVIEWS } from "../../../Api/Api";
import { Axios } from "../../../Api/Axios";

export default function HomeInvestor() {
  const [bestTalents, setBestTalents] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await Axios.get(`${REVIEWS}/${BESTTALENTS}`);
        setBestTalents(data.data.talents);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchUsers();
  }, []);

  const showBestTalents = bestTalents.filter(
    (talent) => talent.average_rating > 3.0
  );


  return (
    <>
      <HomePage bestTalents={showBestTalents} />
    </>
  );
}
